import React, { useEffect, useMemo } from 'react'
import FiltersPanel, { FieldConfig } from '@/components/common/FiltersPanel'
import { FilterValues } from '@/types'
import { Box, Typography } from '@mui/material'
import { useAppDispatch, useAppSelector } from '@/app/hooks'
import { fetchDocumentTags } from '@/features/options/optionsThunks'
import { selectDocumentTags } from '@/features/options/optionsSelectors'

interface DocFilterProps {
    filters: FilterValues
    onApply: (filters: FilterValues) => void
}

const DocFilter: React.FC<DocFilterProps> = ({ filters, onApply }) => {
    const dispatch = useAppDispatch()
    const documentTags = useAppSelector(selectDocumentTags)

    useEffect(() => {
        if (documentTags.length === 0) {
            dispatch(fetchDocumentTags())
        }
    }, [dispatch, documentTags.length])

    const fields: FieldConfig[] = useMemo(() => [
        { key: 'name', label: 'Nombre', type: 'text', placeholder: 'Ingrese nombre del documento' },
        {
            key: 'tag',
            label: 'Seleccione Etiqueta',
            type: 'select',
            options: [
                { value: '', label: 'Todos' },
                ...documentTags.map(tag => ({ value: tag, label: tag }))
            ]
        },
        { key: 'date', label: 'Fecha de última edición', type: 'date' },
        { key: 'editor', label: 'Editor', type: 'text', placeholder: 'Ingrese nombre de editor' }
    ], [documentTags])

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            px: { xs: 4, md: 6, lg: 8 },
        }}>
            <Typography variant="body2" color="text.secondary" sx={{ pb: 2, mr: 4, textAlign: 'center', fontSize: '0.875rem', fontWeight: 500 }}> Acciones Disponibles</Typography>
            <FiltersPanel fields={fields} initialValues={filters} onApply={onApply} />
        </Box>
    )
}

export default DocFilter